import { render } from "./AddImo5Component.vue?vue&type=template&id=7c76d267&lang=true"
import script from "./AddImo5Component.vue?vue&type=script&lang=js"
export * from "./AddImo5Component.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__